import { render, staticRenderFns } from "./HeaderGorizontal.vue?vue&type=template&id=633450cd&"
import script from "./HeaderGorizontal.vue?vue&type=script&lang=js&"
export * from "./HeaderGorizontal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGorizontal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports